import { Droplets, Home, Flame, Receipt, Wrench, Scan } from "lucide-react";

export const services = [
  {
    key: "perdite-acqua",
    icon: Droplets,
    title_it: "Ricerca perdite acqua",
    title_en: "Water leak detection",
    short_it: "Diagnosi non distruttiva con geofono, termocamera e gas tracciante.",
    short_en: "Non-destructive diagnosis with geophone, thermal camera and tracer gas.",
    body_it: "Individuiamo perdite occulte sotto pavimenti, dentro i muri, in giardino o nei tratti interrati. Un foro mirato di pochi centimetri al posto di demolizioni costose.",
    body_en: "We locate hidden leaks under floors, inside walls, in gardens or buried sections. A targeted hole of a few centimeters instead of expensive demolitions.",
  },
  {
    key: "infiltrazioni-tetti",
    icon: Home,
    title_it: "Infiltrazioni e tetti",
    title_en: "Roof infiltrations",
    short_it: "Strumenti Trotec PD200 e termocamere per individuare il punto reale.",
    short_en: "Trotec PD200 tools and thermal cameras to find the true entry point.",
    body_it: "Coppi, tegole, guaine, terrazzi praticabili, lucernari: troviamo dove l'acqua entra davvero — spesso lontano dalla macchia che vedi.",
    body_en: "Tiles, membranes, walkable terraces, skylights: we find where water really enters — often far from the visible stain.",
  },
  {
    key: "antincendio",
    icon: Flame,
    title_it: "Impianti antincendio",
    title_en: "Fire systems",
    short_it: "Sprinkler, naspi, idranti: perdite, manutenzione, test di tenuta.",
    short_en: "Sprinklers, hose reels, hydrants: leaks, maintenance, leak tests.",
    body_it: "Lavoriamo per condomini, capannoni, hotel, ospedali e attività commerciali. Personale specializzato e strumenti dedicati.",
    body_en: "For condos, warehouses, hotels, hospitals, businesses. Certified personnel and dedicated tools.",
  },
  {
    key: "bolletta",
    icon: Receipt,
    title_it: "Bolletta dell'acqua anomala",
    title_en: "Unusual water bill",
    short_it: "Se la bolletta è raddoppiata, hai quasi sicuramente una perdita occulta.",
    short_en: "If your bill doubled, you almost certainly have a hidden leak.",
    body_it: "Test di tenuta del contatore, ispezione delle linee, localizzazione del punto perdita. Ti facciamo risparmiare denaro reale.",
    body_en: "Meter tightness tests, line inspections, leak point localization. We save you real money.",
  },
  {
    key: "video-ispezione",
    icon: Scan,
    title_it: "Video ispezioni",
    title_en: "Video inspections",
    short_it: "Telecamera per scarichi, collettori, pluviali con registrazione e metratura.",
    short_en: "Camera inspection for drains, manifolds and downpipes, with recording.",
    body_it: "Otturazioni ricorrenti? Odori? Vendita immobile? La video ispezione racconta esattamente lo stato dei tubi.",
    body_en: "Recurring clogs? Smells? Property sale? Video inspection tells the exact pipe state.",
  },
  {
    key: "riparazioni",
    icon: Wrench,
    title_it: "Riparazioni mirate",
    title_en: "Targeted repairs",
    short_it: "Trovata la perdita, ripariamo subito — senza sostituzioni inutili.",
    short_en: "Once located, we repair immediately — no useless replacements.",
    body_it: "Lavoriamo su rame, multistrato, PE, polipropilene, acciaio. Riparare costa meno che sostituire: lo dimostriamo.",
    body_en: "We work on copper, multilayer, PE, polypropylene, steel. Repairing is cheaper than replacing — we prove it.",
  },
];
